import React from "react";
import { NavLink } from "react-router-dom";
import { Search, Grid } from "react-feather";
import { paths } from "../../../routes/paths";

// Guard Lookup and Duty List answer the same question from two sides - "who
// guarded where" by customer and dates, or as the month's duty grid - so each
// page links straight to the other (asked 2026-09-14: incorporate the duty
// list with the guard lookup page).
const GuardLookupTabs = () => (
  <ul className="nav nav-pills guard-lookup-tabs mb-3">
    <li className="nav-item">
      <NavLink to={paths.guardingGuardLookup} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
        <Search size={14} className="me-1" /> Guard Lookup
      </NavLink>
    </li>
    <li className="nav-item">
      <NavLink to={paths.guardingDutyList} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
        <Grid size={14} className="me-1" /> Duty List
      </NavLink>
    </li>
  </ul>
);

export default GuardLookupTabs;
